// extracted by mini-css-extract-plugin
module.exports = {"container":"Tasks_container__CJcFq","col":"Tasks_col__3zuqK","header":"Tasks_header__1_Hda","fadeIn":"Tasks_fadeIn__1JbOT","fadeIn2":"Tasks_fadeIn2__1jGTZ"};